import Vue from 'vue'
import VueRouter from 'vue-router'
import {
  logpaths
} from '@/libs/sysconst'
import store from '@/store/index'

// 二级路由
import account from './account'
import assets from './assets'
import invest from './invest'
import security from './security'
import coupon from './coupon'
import borrow from './borrow'
import order from './order'
import autobid from './autobid'
import message from './message'
import help from './help'


Vue.use(VueRouter)

const Router = new VueRouter({
  routes: [
    // {
    //   path: '/',
    //   redirect: '/home',
    //   component: () => import('../pages/home')
    // },
    {
      path: '/',
      redirect: '/account',
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('../pages/home')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../pages/about')
    },
    {
      path: '/webStated',
      name: 'webStated',
      component: () => import('../pages/webStated')
    },
    //我的邀请
    {
      path: '/invite',
      name: 'invite',
      component: () => import('@/pages/invitation')
    },
    // 邀请详情
    {
      path: '/activedetail',
      name: 'inviteDetail',
      component: () => import('@/pages/invitation/detail')
    },
    // 帮助中心
    help,
    // 注册、登录、找回密码
    account,
    // 资产中心
    assets,
    // 投资中心
    invest,
    // 账号设置
    security,
    //卡券
    coupon,
    // 我要借款
    borrow,
    //我的订单
    order,
    //自动投标
    autobid,
    //新闻中心
    message,
    //公告
    // 404
    {
      path: '*',
      // redirect: {
      //   name: 'home'
      // },
      redirect: {
        name: 'login'
      },
    }
  ]
})

// 未登录拦截
Router.beforeEach((to, from, next) => {
  document.body.scrollTop = document.documentElement.scrollTop = 0;
  let fpath = to.matched.length ? to.matched[0].path : to.path;
  if (store.state.user.logstate === false && (logpaths.indexOf(fpath) > -1 || logpaths.indexOf(to.path) > -1)) {
    Router.replace({
      name: 'login',
      query: {
        back: to.path
      }
    })
  } else {
    next()
  }
})


export default Router;
